// extracted by mini-css-extract-plugin
module.exports = {"base":"Link_base__9W8Qs","highlight":"Link_highlight__HdSrf","primary":"Link_primary__rWdtP","secondary":"Link_secondary__m0KtR","blend":"Link_blend___ORVn"};